module.exports = __webpack_public_path__ + "static/media/votl-logo-black.1a2e0678.png";